// Components
import DatePicker from "vue2-datepicker"

// Service
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { comingSoonMixins } from "@/app/mixins/modules/coming-soon-mixins"


// Constants
import { STATUS_CODES } from '@/app/constants/constants.js';

export default {
    name: 'BreederMatingListComponent',
    components: {
        DatePicker
    },
    directive: {},
    filters: {},
    mixins: [
        tableMixins,
        dateMixins,
        toastMessageMixins,
		comingSoonMixins
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            // table
			theads: [
				{
					name: "Mating Name",
					searchLabel: "f_matingName",
					sortLabel: "matingName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
				},
				{
					name: "Sire Name",
					searchLabel: "f_sireName",
					sortLabel: "sireName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
				},
				{
					name: "Dam Name",
					searchLabel: "f_damName",
					sortLabel: "damName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 200px;"
				},
				{ 
					name: "Breed Name", 
					hasSearch: true,
					searchLabel: "f_breedName", 
					sortLabel: "breedName", 
					isDesc: false, 
					style: "min-width: 180px;"
				},
				{
                    name: "Whelping Date",
                    hasWhelpingDateFilter: true,
                    searchLabel: "f_whelpingDate",
                    sortLabel: "whelpingDate",
                    isDesc: false,
                    style: "min-width: 180px;"
                },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false,  style: "min-width: 100px;" },
			],
            // Gender List
            genderList:[{
					value: "dam",
					name: "Dam",
				},
				{
					value: "sire",
					name: "Sire",
				}],
            selectGender:'',
            selectedDateOfBirth:'',
			selectWhelpingDate:'',
			limit: 10,
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},

			breederSysId: null,
			filterValues:{}
        }
    },
    computed: {},
    watch: {
        selectGender() {
			this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
		},
		selectedDateOfBirth() {
			this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
		},
		selectWhelpingDate() {
			this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
		},
    },
    created() {
		this.breederSysId = this.$route.params.id
		this.loadSavedFilters()
        this.getTableContent()
    },
	activated() {
		this.loadSavedFilters()
        this.getTableContent();
	},
    methods: {
		onDataFilter(filterBy, value) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = value;
                this.filterValues[filterBy] = value;
				this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc);
			}
		},
        onColumnDataFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
                this.columnsFilter[filterBy] = event.target.value;
                this.filterValues[filterBy] = event.target.value;
				this.delayTyping(() => {
					this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
				});
			}
		},
        clearFilters() {
            const filters = this.$store.state.breederMatingListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetBreederMatingListFilters');
            }
        },
        saveAllFilters() {
            const filters = {};
                // Collect all the column filter values
                this.theads.forEach(th => {
                    if (th.hasWhelpingDateFilter) {
                        filters[th.searchLabel] = this.selectWhelpingDate;
                    } else {
                        const searchInput = this.columnsFilter[`${th.searchLabel}`];
                        if (searchInput) {
                            filters[th.searchLabel] = searchInput;
                        }
                    }
                });

                // Add pagination details to filters
                filters.page = this.page; // current page
                filters.limit = this.limit; // items per page
				filters.sortBy = this.sortBy
                filters.isDesc = this.desc
                // Dispatch all filters, including pagination, to Vuex store
                Object.keys(filters).forEach(label => {
                    this.$store.dispatch('applyBreederMatingListFilters', { label, value: filters[label] });
                });
          },  
          loadSavedFilters() {
            const filters = this.$store.state.breederMatingListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;

            if (hasFilters) {
				this.page = this.$store.getters.getBreederMatingListFilters('page') || 1;
				this.limit = this.$store.getters.getBreederMatingListFilters('limit') || 10; 
				this.sortBy = this.$store.getters.getBreederMatingListFilters('sortBy') || '';
				this.desc = this.$store.getters.getBreederMatingListFilters('isDesc'); 

				// You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
                    const savedFilter = this.$store.getters.getBreederMatingListFilters(th.searchLabel);

					if(this.sortBy === th.sortLabel) {
						th.isDesc =  this.desc
					}
					if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        if (th.hasWhelpingDateFilter) {
                            this.selectWhelpingDate= savedFilter
                        } else {
                            this.filterValues[th.searchLabel] = savedFilter
                        }
                    }
                }); 
        
                this.clearFilters()
            }
        },  
        getTableContent(
			fromFilter = false,
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
		) {
			page = fromFilter ? 1 : this.page
			this.callMatingListAPI({ page, limit, sortBy, desc })
		},
		callMatingListAPI(queryParams) {
			this.isAPILoading = true

			queryParams["f_breederSysId"] = this.$route.params.id

			if (this.columnsFilter) {
				if (this.columnsFilter.f_sireName) {
					queryParams["f_sireName"] = this.columnsFilter.f_sireName
				}
				if (this.columnsFilter.f_damName) {
					queryParams["f_damName"] = this.columnsFilter.f_damName
				}
                if (this.columnsFilter.f_breedName) {
					queryParams["f_breedName"] = this.columnsFilter.f_breedName
				}
				if (this.columnsFilter.f_matingName) {
					queryParams["f_matingName"] = this.columnsFilter.f_matingName
				}
				
			}

			if (this.selectWhelpingDate) {
                queryParams["f_whelpingDate"] = this.formatDateWithoutConversion(this.selectWhelpingDate, "yyyy-MM-dd HH:mm");
            }
            

			breedingManagementService.getMatingList(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						this.showAPIErrorToast(this.toastMessages.transactions().ERROR_BREEDER_DAM_SIRE, res)
					}

					this.isAPILoading = false
				})
				.catch((err) => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
        showMatingDetails(matingId) {
			if(!matingId){
				return;
			}
		   const savedTabId = localStorage.getItem('selectedTab');
           if (!savedTabId) {
               localStorage.setItem('selectedTab', 'matingList');
           } 
			this.saveAllFilters()
			this.$router.push(`/breeder-management/mating-details/${this.breederSysId}/${matingId}`);
		},
		deleteMatingDetails(data) {
			this.showComingSoonAlert();
			return;

			const { alias, id } = data;
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete this dog mating record?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: 'Delete',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dd3333 !important',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					// API call for delete
					breedingManagementService.deleteMatingDetails(this.breederSysId, id).then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Deleted!', `${alias} has been deleted!`);
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(`Unable to delete ${alias}`, res);
						}
					});
				}
			});
		},
		populateBreedName(sireBreedName, damBreedName) {
			let breedName;
			if (sireBreedName === damBreedName)
				breedName = sireBreedName

			if (sireBreedName !== damBreedName) {
				if (sireBreedName && damBreedName)
					breedName = `${sireBreedName || ''} / ${damBreedName || ''}`
				else if (sireBreedName && !damBreedName)
					breedName = sireBreedName
				else if (!sireBreedName && damBreedName)
					breedName = damBreedName
			}
			
			return breedName	
		},
		capitalizeFirstLetter(word) {
			if (typeof word !== 'string' || word.length === 0) {
			  return word; 
			}
			return word.charAt(0).toUpperCase() + word.slice(1);
		  }
    },
    // third party libraries
}